import Vue from 'vue'

export default {
  updateCompanyLegal({ companyId, fields }) {
    return Vue.http.put(`app-services/v2/company/${companyId}/legal`, fields)
  },
  updateCompany({ companyId, fields }) {
    return Vue.http.put(`app-services/v2/company/${companyId}`, fields)
  },
  addOauth(payload) {
    return Vue.http.post(`app-services/v2/company/add-oauth`, payload)
  },
  fetchCompanies() {
    return Vue.http.get('app-services/v2/users/companies/list')
  },
  fetchCompanyById(id) {
    return Vue.http.get(`app-services/v2/company/${id}`)
  },

  // deprecated nexus endpoints
  create(payload) {
    return Vue.http.post('company', payload)
  },
  list(userId) {
    return Vue.http.get(`company/list/${userId}`)
  },
  update(payload) {
    return Vue.http.post('company/update', payload)
  },
  getTeam(payload) {
    return Vue.http.post('company/get-team', payload)
  },
  getInvite(token) {
    return Vue.http.get(`company/invite/${token}`)
  },
  // deprecated: use the request in campaignSetups service
  textUsage(companyId) {
    return Vue.http.get(`company/${companyId}/text-usage`)
  }
}
